// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"c7840a18","455":"cc9a0057","644":"1749a790"}[chunkId] + ".chunk.js";
};